import { motion } from "framer-motion";
import { X, Check } from "lucide-react";
import { NEVERS, ALWAYS } from "@/data/content";
import { SectionEyebrow } from "@/components/Marquee";

const item = {
  hidden: { opacity: 0, x: -20 },
  show: (i = 0) => ({ opacity: 1, x: 0, transition: { duration: 0.7, delay: 0.1 + i * 0.08, ease: [0.8, 0, 0.2, 1] } }),
};

export default function Promise() {
  return (
    <section id="promise" className="relative py-20 md:py-28 bg-void" data-testid="promise-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <SectionEyebrow n="Ch. IX" testId="promise-eyebrow">Why CaarSaarthi</SectionEyebrow>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.8, 0, 0.2, 1] }}
          className="mt-6 font-serif text-white text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl"
        >
          Two lists. One <span className="italic gradient-text">contract.</span>
        </motion.h2>

        <div className="mt-16 md:mt-20 grid md:grid-cols-2 gap-6 md:gap-8">
          <div className="rounded-3xl border border-red-500/25 bg-[#1a0e11] p-8 md:p-10" data-testid="promise-never-list">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full grid place-items-center bg-red-500/15 text-red-400"><X className="w-5 h-5"/></span>
              <div>
                <p className="text-xs uppercase tracking-[0.25em] text-red-400/80">We Will</p>
                <p className="font-serif text-3xl text-white">Never</p>
              </div>
            </div>
            <ul className="mt-8 space-y-4">
              {NEVERS.map((n, i) => (
                <motion.li
                  key={n}
                  variants={item}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true }}
                  custom={i}
                  className="flex items-start gap-3 text-silver/85"
                >
                  <X className="w-4 h-4 mt-1.5 text-red-400 shrink-0" />
                  <span className="text-lg leading-snug">{n}</span>
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="rounded-3xl border border-white/5 gradient-border bg-surface p-8 md:p-10 relative overflow-hidden" data-testid="promise-always-list">
            <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full opacity-40 blur-3xl gradient-bg pointer-events-none" />
            <div className="relative flex items-center gap-3">
              <span className="w-10 h-10 rounded-full grid place-items-center bg-white/10 text-white"><Check className="w-5 h-5"/></span>
              <div>
                <p className="text-xs uppercase tracking-[0.25em] gradient-text">We Will</p>
                <p className="font-serif text-3xl text-white">Always</p>
              </div>
            </div>
            <ul className="relative mt-8 space-y-4">
              {ALWAYS.map((n, i) => (
                <motion.li
                  key={n}
                  variants={item}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true }}
                  custom={i}
                  className="flex items-start gap-3 text-silver/90"
                >
                  <Check className="w-4 h-4 mt-1.5 text-[#4FC3F7] shrink-0" />
                  <span className="text-lg leading-snug">{n}</span>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
